import { MaterialCommunityIcons } from "@expo/vector-icons";
import { Box, Divider, HStack, Icon, Text, VStack } from "native-base";
import React from "react";

type OrderEvaluationStepperProps = {
  activeIndex: number;
};

const OrderEvaluationStepper = ({ activeIndex }: OrderEvaluationStepperProps) => {
  const steps = ["Experiência", "Entrega", "iFeira"];

  const renderStepper = (step: string, active: boolean, isLast: boolean) => (
    <VStack key={step} flex={0.3} flexGrow={isLast ? undefined : 1}>
      <Text my="2" ml={-2} fontSize="md" color="primary.600">
        {step}
      </Text>
      <HStack alignItems="center">
        <Box bgColor="white.50" rounded="full">
          <Icon
            as={
              <MaterialCommunityIcons
                name={active ? "check-circle" : "checkbox-blank-circle-outline"}
              />
            }
            size="lg"
            color={active ? "primary.600" : "gray.400"}
          />
        </Box>
        {!isLast && (
          <Divider
            w={0}
            flexGrow={1}
            borderWidth="1"
            borderColor={active ? "primary.600" : "gray.400"}
          />
        )}
      </HStack>
    </VStack>
  );

  return (
    <HStack p="2">
      {steps.map((step, index) => {
        const active = index <= activeIndex;
        const isLast = index === steps.length - 1;
        return renderStepper(step, active, isLast);
      })}
    </HStack>
  );
};

export default OrderEvaluationStepper;
